<a mat-flat-button="" class="btn-content" href="{{ question.configuration.href }}" target="_blank">{{ question.configuration.text }}
</a>
